<template>
  <div class="wallpaper flex flex-col items-center justify-center">
    <img src="@/assets/bbt_icon.png" alt="BBT Icon" class="w-17 h-16 mb-4" />
    <div class="text-2xl md:text-3xl lg:text-4xl text-center">
      Before Bots Takeover
    </div>
  </div>
</template>

<script>
export default {
  name: "AppWallpaper",
};
</script>

<style scoped>
.wallpaper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 2.5rem;
  color: #ffffff;
  pointer-events: none;
  text-align: center;
  padding: 0 16px;
}
</style>
